module.exports = __webpack_public_path__ + "img/union_1.b8690516.jpg";